// pipes
import { titleCasePipe } from 'shared/pipes';

import { IconView } from './icon-view';

const ENTERTAINMENTS = ["Books", "Movies, Series or Documentaries", "Podcasts"];

const StyleProfileItem = ({ field, options }) => {

    if (!field || !field.length) {
        return null;
    }

    const data = (typeof (field) === 'string' ? field?.split(',') : field) || [];

    const getClass = (option) => {
        return data.toString().toLowerCase().includes(option.toLowerCase()) ? 'is-large is-primary' : 'is-light';
    }

    return (
        <div className="content">
            <dl>
                <dt className="subtitle is-size-4 is-uppercase">ENTERTAINMENTS</dt>
                <div className="is-flex-mobile is-justify-content-flex-start is-flex-wrap-wrap">
                    {options.map((option) => (
                        <span key={option} className={`tag ${getClass(option)} m-2`}>{option}</span>
                    ))}
                </div>
            </dl>
        </div>
    );
};

const StyleInfoView = ({ title, values }) => {

    return (
        <div className="content column mx-6">
            <dl>
                <dt className="subtitle is-size-4 is-uppercase">{title}</dt>
                <div className="columns is-multiline is-gapless">
                    {values.map((value) => (
                        <IconView value={value} />
                    ))}
                </div>
            </dl>
        </div>
    );
}

const PickedStyleInfo = ({ name, data }) => {

    if (!data) { return null; }

    let d = data;
    if (typeof (data) === 'object') {
        d = data.toString();
    }

    const values = d?.split(',') || [];
    const title = titleCasePipe.transform(name);

    if (!values.length) { return null; }

    return (
        <div className="column has-text-centered is-6-mobile ">
            <StyleInfoView title={title} values={values} />
        </div>
    );
};

const Lifestyle = ({ customer }) => {
    if (!customer || !customer.lifestyle) { return null; }

    return (
        <div className="container">
            <p className="title has-text-centered">
                LifeStyle
            </p>

            <div className="box">
                <div className="block">
                    <StyleProfileItem field={customer.lifestyle.entertainment} options={ENTERTAINMENTS} />

                </div>
                <div className="columns is-8 is-centered has-background-light is-multiline is-mobile">
                    <PickedStyleInfo name="Weekdays" data={customer.lifestyle.weekday} />
                    <PickedStyleInfo name="Week-end" data={customer.lifestyle.weekend} />
                </div>
            </div>
        </div>
    );
}

export { Lifestyle };
